<template>
    <ion-card>
        <ion-card-header style="background-image: linear-gradient(to bottom, rgb(110, 222, 174), white)">
            <ion-card-title style="font-size: 22px; text-align: left">Arrivals Today</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <ion-label style="display: flex; justify-content: center; font-weight: 700" v-if="dataArray.length <= 0"
                >No Arrivals Today</ion-label
            >
            <div v-if="dataArray.length > 0">
                <ion-list
                    v-for="(item, index) in dataArray"
                    :key="index"
                    :value="item"
                    style="padding: 0px; margin: 0px"
                >
                    <ion-item lines="full">
                        <ion-grid style="padding: 0px; margin: 0px; padding-bottom: 8px; padding-top: 8px; width: 100%">
                            <ion-col style="padding: 0px; margin: 0px">
                                <ion-row style="padding: 1px; margin: 0px; width: 100%">
                                    <ion-label
                                        style="
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            width: 100%;
                                        "
                                        >{{ dataArray[index].reservation.guest_name }}</ion-label
                                    >
                                </ion-row>
                                <ion-row style="padding: 1px; margin: 0px">
                                    <ion-label
                                        style="
                                            font-size: smaller;
                                            font-weight: 500;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            width: 100%;
                                        "
                                        >{{ dataArray[index].property_name }}</ion-label
                                    >
                                </ion-row>
                            </ion-col>
                        </ion-grid>
                        <!--<div style="padding: 0px; margin: 0px" slot="end" class="ldx-reservation-card-icon">
                            <ion-icon
                                class="ldx-large-icon"
                                @click="openChat('0')"
                                :icon="chatbubblesOutline"
                                style="margin-top: 7px; cursor: pointer"
                            >
                            </ion-icon>
                        </div>-->
                        <div style="padding: 0px; margin-right: 0px; margin-left: 10px" slot="end">
                            <ion-icon
                                class="ldx-large-icon"
                                @click="openModal(dataArray[index].reservation.id.toString())"
                                :icon="ellipsisVerticalOutline"
                                style="margin-top: 6px; cursor: pointer"
                            >
                            </ion-icon>
                        </div>
                    </ion-item>
                </ion-list>
                <ion-label
                    v-if="dataArray.length >= 8 || listSize >= 8"
                    style="display: flex; justify-content: center; padding-top: 8px"
                    >{{ offset + 1 }} to {{ dataArray.length + offset }} of {{ dataCount }}</ion-label
                >
                <div
                    v-if="dataArray.length >= 8 || listSize >= 8"
                    style="display: flex; justify-content: space-between; width: 100%; white-space: nowrap"
                >
                    <div>
                        <ion-button
                            @click="toStart()"
                            color="primary"
                            style="--border-radius: 10px; max-width: 50px; max-height: 50px; width: 100%; height: 100%"
                            size="default"
                            ><img src="./../../assets/icons/skip-left-all.png"
                        /></ion-button>
                        <ion-button
                            @click="backButton()"
                            color="primary"
                            style="--border-radius: 10px; max-width: 50px; max-height: 50px; width: 100%; height: 100%"
                            size="default"
                            ><img src="./../../assets/icons/skip-left.png"
                        /></ion-button>
                    </div>
                    <div>
                        <ion-button
                            @click="nextButton()"
                            color="primary"
                            style="--border-radius: 10px; max-width: 50px; max-height: 50px; width: 100%; height: 100%"
                            size="default"
                            ><img src="./../../assets/icons/skip-right.png"
                        /></ion-button>
                        <ion-button
                            @click="toEnd()"
                            color="primary"
                            style="--border-radius: 10px; max-width: 50px; max-height: 50px; width: 100%; height: 100%"
                            size="default"
                            ><img src="./../../assets/icons/skip-right-all.png"
                        /></ion-button>
                    </div>
                </div>
            </div>
        </ion-card-content>
    </ion-card>
</template>

<script lang="ts">
    import { defineComponent, onMounted, ref, watch } from 'vue';
    import AppAPI from '@/services/AppAPI';
    import { mailOutline, ellipsisVerticalOutline, chatbubblesOutline } from 'ionicons/icons';
    import { useStore } from '@/store/store';
    import ModalController from '@/services/ModalController';
    import { useIonRouter } from '@ionic/vue';
    import { departureArrivalWidgetContentArray } from '@/types/types';

    export default defineComponent({
        components: {},
        setup() {
            const store = useStore();
            const dataArray = ref([] as departureArrivalWidgetContentArray[]);
            const offset = ref(0);
            const listSize = ref(8);
            const dataCount = ref(0);
            const ionRouter = useIonRouter();

            const openChat = (chatId: string) => {
                store.changeActivePage('/unifiedInbox/subscriber/0/inbox/0/conversation/' + chatId);
                window.location.href = '/unifiedInbox/subscriber/0/inbox/0/conversation/' + chatId;
            };

            const openModal = async (reservationId: string) => {
                await ModalController.controlPanelModal(reservationId);
            };

            const getInformattion = async () => {
                let data = await AppAPI.getPendingWidgetContent(offset.value.toString());
                if (data) {
                    dataCount.value = data.data.total_records;
                    dataArray.value = data.data.data;
                }
            };

            const backButton = () => {
                if (offset.value <= 0) {
                    return;
                } else {
                    if (offset.value - listSize.value < 0) {
                        offset.value = 0;
                        getInformattion();
                    } else {
                        offset.value = offset.value - listSize.value;
                        getInformattion();
                    }
                }
            };

            const nextButton = () => {
                if (offset.value + listSize.value >= dataCount.value) {
                    return;
                } else {
                    offset.value = offset.value + listSize.value;
                    getInformattion();
                }
            };

            const toStart = () => {
                offset.value = 0;
                getInformattion();
            };

            const toEnd = () => {
                if (dataCount.value < listSize.value) {
                    return;
                }
                offset.value = dataCount.value - listSize.value;
                getInformattion();
            };

            watch(
                () => store.arrivalDataArray,
                async () => {
                    dataArray.value = store.arrivalDataArray;
                }
            );

            watch(
                () => store.arrivalDataCount,
                async () => {
                    dataCount.value = store.arrivalDataCount;
                }
            );

            onMounted(async () => {
                dataArray.value = store.arrivalDataArray;
                dataCount.value = store.arrivalDataCount;
            });

            return {
                ionRouter,
                mailOutline,
                ellipsisVerticalOutline,
                chatbubblesOutline,
                dataArray,
                offset,
                listSize,
                dataCount,
                openChat,
                openModal,
                getInformattion,
                backButton,
                nextButton,
                toStart,
                toEnd,
            };
        },
    });
</script>

<style scoped></style>
